module.exports = __webpack_public_path__ + "img/icon_user.23c42f65.svg";